// extracted by mini-css-extract-plugin
export var heading = "TimeLineSection-module--heading--hD2RP";